<template>
    <div v-if="questions">
        <div>
            <v-layout row wrap class="symptom-card-title">
                <v-flex sm3 class="progress-circle-status">
                    <div class="cont-svg" >
                        <v-progress-circular
                            :value="questionsCountAnswered * 100 / questionsCountTotal"
                            class="color-circular-progress"
                            :rotate="-90"
                            :width="2">
                            <radial-progress-svg
                                v-if="questionsCountAnswered === questionsCountTotal"
                                class="margin-top-xxs">
                            </radial-progress-svg>
                        </v-progress-circular>
                    </div>
                </v-flex>

                <v-flex sm9>
                    <span v-if="mustShowCodes && symptomCode" class="font-size-small font-weight-light">
                        [{{ symptomCode }}]&nbsp;
                    </span>
                    <span :class="titleClasses">
                        {{title}}
                    </span>
                    <div class="answered-questions color-body font-size-extra-small font-weight-light">
                        {{questionsCountAnswered}} {{text('api.pro.questionPanel.of')}} {{questionsCountTotal}} {{text('api.pro.questionPanel.answeredQuestions')}}
                    </div>
                </v-flex>
            </v-layout>
        </div>

        <symptom-question-item
            :ref="'symptomQuestionItemRef_' + question.code"
            v-for="question in questions"
            :key="question.code"
            :questionData="question"
            :mustShowFullQuestion="mustShowFullQuestion"
            @onProvideQuestionAnswer="handleProvideAnswer"
            @emitQuestionClick="onQuestionClick"
            :shortcutNav="shortcutNav">
        </symptom-question-item>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import SymptomQuestionItem from "./SymptomQuestionItem";
    import RadialProgressSvg from "../svg/productList/radialProgress";

    export default {
        name: 'QuestionListBlock',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg
        },

        props: {
            questions: {},
            title: {
                type: String,
                default: ""
            },
            titleClasses: {
                type: String,
                default: "title-assessment-sections"
            },
            symptomCode: {},
            questionsCountAnswered: {
                type: Number,
                default: 0
            },
            questionsCountTotal: {
                type: Number,
                default: 0
            },
            shortcutNav: {}
        },
        data(){
            return{
                fill : { gradient: ["red"] }
            }
        },
        computed: {
            ...mapGetters({
                mustShowFullQuestion: 'ProductListStore/getMustShowFullQuestion',
                mustShowCodes: 'UserStore/getDebugMustShowCodes',
            }),

        },

        methods: {
            handleProvideAnswer(data) {
                this.$emit('onProvideAnswer', data);
            },

            onQuestionClick(data) {

                // Will have value only if "QuestionListBlock" is used for a Symptom
                data.symptomCode = this.symptomCode;

                this.$emit('emitQuestionClick', data);
            },
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss">
    .cont-svg {
        content: '%';
    }

    /*.progress-circle-status {*/
    /*    max-width: 45px !important;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/common/components/shared/QuestionListBlock.vue